import Crud from '../views/Involved/Crud'
import Entity from '../views/Involved/Add'

let routes = {
    path: '/involveds',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/involveds/add',
            name: 'NewInvolved',
            component: Entity,
            meta: {
                pageTitle: 'involved.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'involved.form.newTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/involveds/edit/:id?',
            name: 'EditInvolved',
            component: Entity,
            meta: {
                pageTitle: 'involved.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'involved.form.editTitle',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/involveds',
            name: 'list-involveds',
            component: Crud,
            meta: {
                pageTitle: 'involved.crud.title',
                access_nivel: ['1'],
                breadcrumb: [
                    {
                        text: 'involved.crud.title',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
